import { Grid2 as Grid, Typography } from "../../platform-style";

interface OverviewLabelValueProp {
  label: string;
  value: string | null | undefined;
  id?: string;
  bottomMargin?: string; // Optional custom bottom margin
}

export const LabelValueForOverview = ({
  id,
  label,
  value,
  bottomMargin,
}: OverviewLabelValueProp) => {
  let internalID: string = label.replace(/\s/g, "");

  return (
    <Grid container direction={"column"} sx={{ pb: bottomMargin ? bottomMargin : "24x" }}>
      <Grid id={"label" + id}>
        <Typography variant={"bodyMedium"}>{label}</Typography>
      </Grid>
      <Grid id={id ? id : "value" + internalID}>
        <Typography variant={"titleMedium"}>{value ? value : ""}</Typography>
      </Grid>
    </Grid>
  );
};
